package com.essntl.features.organization.data.supabase

import com.essntl.features.address.data.supabase.AddressDto
import com.essntl.features.organization.domain.model.OrganizationModel
import io.github.jan.supabase.postgrest.query.Columns
import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class OrganizationDto(
    val id: String,
    val name: String,
    @SerialName("address_id_data")
    val address: AddressDto? = null,
    val website: String? = null,
    @SerialName("logo_file_id")
    val logoFileId: String? = null,
    @SerialName("parent_id")
    val parentId: String? = null,
    val notes: String? = null,
    val type: String? = null,
    @SerialName("created_at")
    val createdAt: String,
    @SerialName("updated_at")
    val updatedAt: String,
) {
    fun toModel() =
        OrganizationModel(
            id = id,
            name = name,
            address = address?.toModel(),
            website = website,
            logoFileId = logoFileId,
            parentId = parentId,
            notes = notes,
            type = when (type) {
                "TRAVEL_AGENCY" -> OrganizationModel.Type.TravelAgency
                "SUPPLIER" -> OrganizationModel.Type.Supplier
                "DMC" -> OrganizationModel.Type.DMC
                else -> null
            },
            createdAt = createdAt,
            updatedAt = updatedAt,
        )

    companion object {
        const val COLUMNS_VALUE = "*, address_id_data:address_id(*)"
        fun getColumns() = Columns.raw(COLUMNS_VALUE)
    }
}

fun OrganizationModel.Type.toDto() =
    when (this) {
        OrganizationModel.Type.TravelAgency -> "TRAVEL_AGENCY"
        OrganizationModel.Type.Supplier -> "SUPPLIER"
        OrganizationModel.Type.DMC -> "DMC"
    }